module.exports = __webpack_public_path__ + "img/Foodlight.be0b4004.svg";